import { Show, TabbedShowLayout, useRecordContext } from "react-admin";
import { GroupTypeEnum } from "shared/enums/globalEnums";
import GroupBasicInfos from "./showTabs/GroupBasicInfos";
import GroupMaintenances from "./showTabs/GroupMaintenances";
import GroupMapContainer from "./showTabs/GroupMap";
import PlanningsAndMasks from "./showTabs/PlanningsAndMasks";
import RteCommunicationGraphVisualizations from "./showTabs/RteCommunicationGraphVisualizations";

export const GroupShow = () => {
  return (
    <Show>
      <ShowTabs />
    </Show>
  );
};

const ShowTabs = () => {
  const group = useRecordContext();
  const isEdr = group && group.type === GroupTypeEnum.rte_edr;
  return (
    <TabbedShowLayout>
      <TabbedShowLayout.Tab label="Basic Infos">
        <GroupBasicInfos />
      </TabbedShowLayout.Tab>
      {isEdr && (
        <TabbedShowLayout.Tab label="RTE communication">
          <RteCommunicationGraphVisualizations />
        </TabbedShowLayout.Tab>
      )}
      <TabbedShowLayout.Tab label="Plannings and Masks">
        <PlanningsAndMasks />
      </TabbedShowLayout.Tab>
      <TabbedShowLayout.Tab label="Maintenances">
        <GroupMaintenances />
      </TabbedShowLayout.Tab>
      <TabbedShowLayout.Tab label="Map">
        <GroupMapContainer />
      </TabbedShowLayout.Tab>
    </TabbedShowLayout>
  );
};
